import { getCalendarFolderId, getDefaultCalendar } from 'owa-calendar-cache';

import { onLoadTheme } from 'owa-theme-common';
import { orchestrator } from 'satcheljs';
import { refreshAssignedColorScheme } from 'owa-calendar-color-resolver';
import { updateCachedColors } from '../actions/updateCachedColors';

orchestrator(onLoadTheme, () => {
    // Resolve the default calendar's color to avoid color overlap
    const defaultCalendar = getDefaultCalendar();
    if (defaultCalendar) {
        const colors = refreshAssignedColorScheme(
            {
                ...defaultCalendar.calendarId,
                id: defaultCalendar.calendarId.id,
            },
            true /* lockColor */
        );
        let calendarFolderId = getCalendarFolderId(defaultCalendar);
        updateCachedColors(colors, calendarFolderId);
    }
});
